// Flags taken from here:
// https://github.dev/uber/baseweb/blob/5dea1e703755eae8c9075bea709042c40ef92a90/src/phone-input
/**
 * MIT License
 *
 * Copyright (c) Uber Technologies, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
export const FlagImageUS =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURfT09L4pPLUmOPv7+8stQj4+cUREe+rq7Z2dtaCguqSkvqamwKOjvTQr3qUAAAEoSURBVDjLvY9BbsIwEEUtWSpKu4mjHKDhBJF6gVrKAVqVcckOqbWllg0bpHIAxJYNZdtVz9EV5+qMEzBYI1gQ5eeP/e28OGPhjvVexXoUHQDTu+C3h1ilcJMymAU+b4NZwLmfX/eH3vE9GOfkTWsWsNatv916h6O17AkfiTuY68FMBDyRDY4vDGDrxIwTUy+gXhgOMADbJaw2sN0Y4HoAa2dzaAyj3O/qKqciIwCwWra2oyr3qipfSCAw/grmeoDXQTALXDzhWM8qVhoBOldaK0UjldYpd0J+coIsS4nVjFLiX2k6ZCH8CyFkC4aEkTISGJrlaaJIszqvtAOgB13soWiUqSJKmRfeIstoURT7b4Y+73d6ucXwvO47AK7XQMyoIrcTPj3c4h9AjuvkAwAS6wAAAABJRU5ErkJggg=='

export const FlagImageGB =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtCAMAAAAun0N9AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABXUExURdseNQQQkOIkO9cbMQkWpP38/AgUn/X09fr6+gMOitMYLtAVLEVOsNnb6+JVZvPb3d4wRRAbk42SzBUhpuudppyg0/K/xehzgOqKle2psaWq3MSDoXV8xdcCecoAAAJXSURBVEjH1ZbrkoIwDIUjUBoEFCkoOvv+z7m5FGihqPtzAyok5+s5MAwjGGNsU+zLmGwp0iQUP9YMABPS9OX+zLuXuV7gAXC5JiN84BuLE3R3A/cOJpOI8Jb35tYYMPahEdrma75prZhTQdMaijDw8ei+4t3IBJuTJxSu30co93yZMO9dAWVJHfPssgE1QslbWWDIIzLPfTfiak7nwHJKRLeDIiC2TclVlCFPK5daZP4gc2rg6FgHKm9alAhosHfSQgx4xFLMezafLMnER/x1AcolEebRnl/NqUbnA3l+jtANPO2LgIfZfzGfLzLiKd1rjsAC4kE22pkXcxmu5jHPAXHIJKDt2d/jzKs5LpeX5DUCq7i8P4g/4kPNXy4iAA8LYF4B34hSTasjtpb9r/zqzxX424TouDK9gk+Vfd0MZtlGMp9nCTZb78TnNP+zctp0z5fj5SQPD3OIvujDxad+GosXSEe7qV8qD3+9KhRt+/IrxvawvIA+xxq74zHgvUce99/zW//8g/8prNvIvWc3pfnpcrXjLSIint5R1so7zP5s+J75O72ibdsc8LO5aoQ/y8Z8uHYYAVLmPQmIJ1Zw4U8niTDQKzqMAJH5sAb0+XmNs/Jbh5DfjCrmz75yz1eVj5B1zyUCcPvWh+YV4wGv/tw7VbsIsGuqcMfLslV120SAxVzui3izbstLT2axG0SnlS8Sb3nuaemtpv8QHAF8HDFXUoXE1+daSvmgZs/HlZ//+aGIJMTXnq7rlT9tI0BonuTrkI8j3C/09zFl/plfI6TMv+B9hF+1DkKtqh2ivgAAAABJRU5ErkJggg=='

export const FlagImageAU =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtCAMAAAAun0N9AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURQMOi9kdNYKIzNcaMgoXpQkVofn5+QYSlgUQkQgUnKmt3Fdfue++xN7f8DI8qfLj5snM5t07UOqQm+JkdG11wVReQoQAAAJlSURBVEjH5VbruqMgDAyoXFW08v7PurmAorZdz9mfO9CahMwkWvArvNbRhJ6gjVLKaLb7YNJW7W8AM6qXmeKZHyfzUpuJD/jZpHVNRNv5czDjiqpL/4DfRxSg5LnytcHi+139lT/Mk9nUlkxgflioOLq5H/oB551DcQKtAX7mRQoyH5+b4nZkvebW/FaTbOCFgAJqZP6oFD+Og1g5Nz1aA81YTHoVPl5N4GAezrlTCNNwAZgG3H+DeM4NKHzjd0p1qmOgwSCfbKOf81VzrRrC9zxolv69RGUBGu4VxMeUIrCzdsnb/RPndP+eMPg3KA14ef4h8XMn/vhKZpEfJUppLz34UrYGBUDLGrdcpwq/w90Thrby2wYOPm+/Dnes9I9SGx4d/wzgc0pbh7t3CcwP5G5pmr+Q6IeofDyrVDxlr5mv5TSkKX7m00aofCkesFzhkzGuGMve8mDY6tidzy6s/Pohp/DRihMeQhagHO7WFgGepX+yAZ+bHjhc+Wj39AYak1C4mj0PmmwAnnSJWHwR4emPbNs8GbOISXxrW/LhWMiiRYg66yir+Im5l3Dpv8HhebBX+C/eHWB/iDnO/8SPJj7hOxw0q7fbt/quDmfbUTT2uPhF9hjgdpQye46QS7wJSLDkQCN2hSTb1nWNLgNODH3KO0y7q7mLWsu3s5ndD9Hw6UWyzP63/Fhfmr/gA11FILPDAWiGJB7X85DQgvTAHjTT7RXyPGdX84841K/J4AD3caD+UnL3GDR9LtHFxYJAciSlRPCPia4rb+DqxdWOLgGqX6JH318E4RyX+79GP+JR0n+PP4FDQYr+OF9+AAAAAElFTkSuQmCC'

export const FlagImageCA =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURf39/f8PD/Py8v8ZGf8FBf8hIf8pKfj4+P8vL/uJif1gYPq8vM2CApsAAAIqSURBVDjL1ZA/b9QwGMa9tAG6nGUvHc+qFLGdsTJ0a6R8gBNRbmE5CSU6OqU+IXN0QQgCYusfqTp1o4iqYmOgEp+O57UTSI4KMbDw2I59z/t7H1vH3ndifd3r3FfsnwALryHQNE0LVFXVeA2AbXQ0DWpztmhVDYGGyrDnlBA0BMhZ+IQ/ANXfAbOymkHlJhDMGYCixAkr6mt7VlVklnNWkgosaqwxI/pulUWB1nI2ZQUJRBFad1DHtkUtIIppuIIg+HUdvYhdVDv3vGjVJpBcXbvIfbtFnRJ+B6LIRQ9uP19/R32QkGP4K9D/8rD5cFgjC0Dix4QlSV4kJAfdB/jM0RvyPEclTybM5InJc2Ny+NExgCdELuERYqaMyjglxu04awE8su7YLZPQSAmd3OrL2cVbY96dXd4gAUqw+oB9muxfmfwmMY8DYDYAd9Udr+8GVpo2jbHfB7QRRuAj3EpwSGAAEFp7e8RworLAFSfYqM4v3FJTEmoTJrjWmJpbu+JBu9YeeVILJGjhxbWL1UkATuP4CC2+MmJcc5qCK2sfrtdyd73GHzYmBzYHwFtExbFT6s1rFeM0pqcQ44EgZRXmp4+WNO7cHhDjjlidnyqKuAuAj4Tzr9aqYUIq6SC5Qj2OcQ9pLKXkKZdyxLB70RWh6B+ZcnRKSkCAlBmm6mtPZplM0yw9YBlECZtAqwPmiyn4X1W8dg+Gbw0JGf0cJqTk4fMTyDaAzv0/gB8wXU1Tj2nJ4wAAAABJRU5ErkJggg=='

export type PhoneCountryCode = 'US' | 'CA' | 'GB' | 'AU'
export type PhoneCountry = {
  name: string
  flagSrc: string
  code: PhoneCountryCode
  prefix: string
}

export const COUNTRIES: Array<PhoneCountry> = [
  {
    name: 'United States',
    flagSrc: FlagImageUS,
    code: 'US',
    prefix: '+1',
  },
  {
    name: 'Canada',
    flagSrc: FlagImageCA,
    code: 'CA',
    prefix: '+1',
  },
  {
    name: 'United Kingdom',
    flagSrc: FlagImageGB,
    code: 'GB',
    prefix: '+44',
  },
  {
    name: 'Australia',
    flagSrc: FlagImageAU,
    code: 'AU',
    prefix: '+61',
  },
]

export const COUNTRIES_LOGIN_ALLOWED = COUNTRIES
export const COUNTRIES_SIGNUP_ALLOWED = COUNTRIES.filter(
  (entry) => entry.code === 'US',
)
